import { render, staticRenderFns } from "./customercompliment.vue?vue&type=template&id=3fc24c5e&scoped=true"
import script from "./customercompliment.vue?vue&type=script&lang=js"
export * from "./customercompliment.vue?vue&type=script&lang=js"
import style0 from "./customercompliment.vue?vue&type=style&index=0&id=3fc24c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc24c5e",
  null
  
)

export default component.exports